<form class="dialog-form" [formGroup]="form" [class.disabled]="loading">
    <div class="p-5" style="padding-bottom: 0">
        <p class="text-lg mb-3">Create New Discrepancy</p>
    </div>
    <div class="flex flex-column gap-15 dialog-fields pl-5">
        <app-select
            label="REASON"
            [searchable]="true"
            [options]="options.reason"
            formControlName="reasonId" />
        <app-input
            label="PAGE RANGE"
            formControlName="pageRange"
            [control]="pageRange">
            @switch (true) {
                @case (pageRange.hasError('pageRangeFormat')) {
                    <app-page-range-format-error
                        error
                        class="color-status-red5" />
                }
                @case (pageRange.hasError('pageRangeConflict')) {
                    <app-page-range-conflict-error
                        error
                        [data]="pageRangeConflictData" />
                }
            }
        </app-input>
        <div class="flex flex-column">
            <app-select
                label="STATION"
                [required]="true"
                [options]="options.station"
                [value]="data.station"
                [control]="stationId"
                formControlName="stationId" />
            @if (
                stationId.hasError('required') ||
                stationId.hasError('optionNotFound')
            ) {
                <span class="text-xxs text-light color-status-red5 mt-1">
                    Station is required.
                </span>
            }
        </div>
        <app-select-users
            label="FIXER"
            [options]="fixers"
            [value]="data.fixer"
            formControlName="primaryFixerId" />
        <app-textarea
            label="DIRECTIONS"
            formControlName="directions"
            [maxLength]="maxDirectionsLength" />
        @if (customColumns.length > 0) {
            <ng-container formGroupName="customColumns">
                @for (col of customColumns; track col.id) {
                    @if (isCustomColumnListBox(col)) {
                        <app-select
                            [label]="getCustomColumnLabel(col)"
                            [formControlName]="col.columnName"
                            [options]="getCustomColumnOptions(col)" />
                    } @else if (isCustomColumnDate(col)) {
                        <app-datepicker
                            [label]="getCustomColumnLabel(col)"
                            [formControlName]="col.columnName"
                            [style.width]="'100%'" />
                    } @else {
                        <app-input
                            [label]="getCustomColumnLabel(col)"
                            [type]="getCustomColumnInputType(col)"
                            [maxLength]="
                                isCustomColumnNumber(col)
                                    ? null
                                    : customColumnMaxLength
                            "
                            [integerOnly]="isCustomColumnNumber(col)"
                            [trimOnBlur]="!isCustomColumnNumber(col)"
                            [hideNumberSpinner]="isCustomColumnNumber(col)"
                            [min]="
                                isCustomColumnNumber(col)
                                    ? customColumnIntMin
                                    : null
                            "
                            [max]="
                                isCustomColumnNumber(col)
                                    ? customColumnIntMax
                                    : null
                            "
                            [formControlName]="col.columnName" />
                    }
                }
            </ng-container>
        }
        <app-info-box>
            Any change in data on the fields shown will create a discrepancy
            that can be treated as a <b>draft</b> until mandatory fields are
            populated and 'notify' action is taken by the user.
        </app-info-box>
    </div>
    <div class="p-5 pt-0">
        <div class="flex justify-end gap-8">
            @if (error) {
                <small class="color-status-red4">
                    Discrepancy could not be created.
                </small>
            }
            <app-flat-button
                [disabled]="loading"
                [dataQa]="dataQa.addDiscrepancyDialogCancel"
                (clicked)="cancel()">
                Cancel
            </app-flat-button>
            <app-flat-button
                variant="cta"
                [disabled]="isCreateDisabled()"
                [dataQa]="dataQa.addDiscrepancyDialogCreate"
                (clicked)="create()">
                Create
            </app-flat-button>
        </div>
    </div>
</form>

@if (loading || rulesLoading) {
    <app-loader type="overlay" size="medium" />
}
